export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Repetir operación"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Historial de operaciones"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lista de cuentas"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error desconocido"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lista de tokens"])}
}